import { commons } from './commons'
import { authHeader } from '@/helpers/auth-header'

export const houseBLService = {
    getHouseBLById,
    getSeaTrackingById
}

const resourceUrl = process.env.VUE_APP_GSCV_ENGINE_URL + `/houseBL`

function getHouseBLById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(resourceUrl + `/${id}`, requestOptions).then(
        commons.handleJsonResponse,
    )
}

function getSeaTrackingById(houseBLId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(resourceUrl + `/sea-tracking/${houseBLId}`, requestOptions).then(
        commons.handleJsonResponse,
    )
}